import {
    ENROLL_COURSE,
    ENROLL_LOADING,
    COURSES_LOADING,
    GET_ALL_COURSES,
    ADD_PAYMENT_PROOF,
    DASHBOARD_LOADING,
    GET_DASHBOARD_DATA,
    DOWNLOAD_LOADING,
    RESULT_DETAILS,
} from '../types';

const initState = {
    enrollmentLoading: false,
    dashboardLoading: false,
    downloadLoading: false,
    dashboardData: null,
    loading: false,
    courses: [],
    result: null,
}

export default (state = initState, action) => {
    let { payload, type } = action;

    switch (type) {
        case GET_ALL_COURSES:
            return {
                ...state,
                loading: false,
                courses: payload,
            }

        case COURSES_LOADING:
            return {
                ...state,
                loading: payload
            }

        case ENROLL_COURSE: {
            let courses = [...state.courses].map(course => {
                if(course.id === payload.id) {
                    return {
                        ...course,
                        enrollment: {
                            ...course.enrollment,
                            status: payload.status,
                            id: payload.enrollment_id,
                        }
                    }
                } else {
                    return course;
                }
            })

            return {
                ...state,
                courses,
                enrollmentLoading: false
            }
        }

        case ENROLL_LOADING:
            return {
                ...state,
                enrollmentLoading: payload
            }

        case ADD_PAYMENT_PROOF:{
            let courses = [...state.courses].map(course => {
                if(course.id === payload.id) {
                    return {
                        ...course,
                        enrollment: {
                            ...course.enrollment,
                            payment_status: payload.status
                        }
                    }
                } else {
                    return course;
                }
            })

            return {
                ...state,
                courses,
                enrollmentLoading: false
            }
        }

        case GET_DASHBOARD_DATA:
            return {
                ...state,
                dashboardData: payload,
                dashboardLoading: false,
            }

        case DASHBOARD_LOADING:
            return {
                ...state,
                dashboardLoading: payload
            }

        case RESULT_DETAILS:
            return {
                ...state,
                result: payload,
                downloadLoading: false,
            }

        case DOWNLOAD_LOADING:
            return {
                ...state,
                downloadLoading: payload
            }
    
        default:
            return state;
    }
}